// Data que se repete todo ano (ex.: data-base do reajuste coletivo), guardada
// como 'DD/MM' pelo hr-admin. Aqui só se formata para exibição.
const MONTH_NAMES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

const DAY_MONTH_PATTERN = /^(\d{2})\/(\d{2})$/;

/** 'DD/MM' → '1º de maio'. Se não for um dia/mês válido, devolve o texto como veio. */
export function formatDayMonthLong(value: string | null | undefined): string {
  const match = DAY_MONTH_PATTERN.exec(value ?? '');
  if (!match) {
    return value ?? '';
  }
  const day = Number(match[1]);
  const month = Number(match[2]);
  if (day < 1 || day > 31 || month < 1 || month > 12) {
    return value;
  }
  return `${day === 1 ? '1º' : day} de ${MONTH_NAMES[month - 1]}`;
}
